import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Form, Formik } from "formik";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import StepRoutes from "../../../Routes/steps_routes";
import CustomInput from "../../../CustomComponent/custom_input";
import CustomSelect from "../../../CustomComponent/custom_select";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import LoadingPage from "../../../Components/layouts/loading";
import { AgronomyWikiInfo, HMInventoryInfo } from "../../../SchemaInfo/info";
import { AgronomyWikiSchema } from "../../../Schemas/Agronomy Wiki/agronomywiki_schema";
import CustomTextArea from "../../../CustomComponent/custom_textarea";
import CustomCheckbox from "../../../CustomComponent/custom_checkbox";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { HMInventorySchema } from "../../../Schemas/purchase/hm_inventory_schema";
import { extractDate } from "../../../Components/Functions/date.fun";
import { useSelector } from "react-redux";

const EditHMInentory = () => {
  const store = useSelector((store) => store.login.user);
  const [hmInventoryInfo, setHMInventoryInfo] = useState(HMInventoryInfo);
  const [loading, setLoading] = useState(false);
  const [vendorList, setVendorList] = useState([]);
  const [data, setData] = useState();
  let { id } = useParams();
  const navigate = useNavigate();

  const hydroponicOptions = [
    { value: "flatbed", label: "Flatbed" },
    { value: "growbags", label: "Grow-bags" },
    { value: "foggers", label: "Foggers" },
    { value: "cea", label: "CEA" },
    { value: "planters", label: "100 Planters" },
    { value: "dutch_bucket", label: "Dutch Bucket" },
    { value: "sikit", label: "Si Kit" },
    { value: "officeItems", label: "Office Items" },
    { value: "tools", label: "Tools And Machinery" },
    { value: "notdefined", label: "Not Defined" },
    { value: "adiAcc", label: "Additional Accessories" },
    {
      value: "fertilizer_self_consumption",
      label: "Fertilizers / Self Consumption",
    },
    {
      value: "hydroponic_raw_material",
      label: "Hydroponic - Raw Material",
    },
    {
      value: "cea_raw_material",
      label: "CEA - Raw Material",
    },
  ];

  const fabricationProcessOptions = [
    { value: "repacking", label: "Repacking" },
    { value: "bending", label: "Bending" },
    { value: "punching", label: "punching" },
    { value: "holemaking", label: "Hole-Making" },
    { value: "cutting", label: "Cutting" },
    { value: "welding", label: "Welding" },
    { value: "painting", label: "Painting" },
    { value: "assembly", label: "Assembly" },
  ];

  const gstOptions = [
    { value: "0", label: "0" },
    { value: "5", label: "5" },
    { value: "12", label: "12" },
    { value: "18", label: "18" },
    { value: "28", label: "28" },
  ];

  const locationOptions = [
    { value: "decWarehouse", label: "DEC-Warehouse" },
    { value: "kryzenOffice", label: "Kryzen Office" },
  ];

  const materialTypeOptions = [
    { value: "gi", label: "GI" },
    { value: "alumunium", label: "Alumunium" },
    { value: "stainless_steel", label: "Stainless Steel" },
    { value: "tmt_bar", label: "TMT Bar" },
    { value: "rubber", label: "Rubber" },
    { value: "hdpe_plastic", label: "HDPE Plastic" },
    { value: "food_grade_pipe", label: "Food Grade Pipe" },
    { value: "pvc", label: "PVC" },
    { value: "upvc", label: "UPVC" },
    { value: "net", label: "Net" },
    { value: "flim", label: "Film" },
    { value: "fertilizers", label: "Fertilizers" },
    { value: "otherItems", label: "Other Items" },
  ];

  // const handelSubmit = (values) => {
  //   console.log("values are", values);
  //   const formData = new FormData();

  //   // Update stockUpdateHistory if cost or inStock has changed
  //   if (values.cost !== data.cost || values.inStock !== data.inStock) {
  //     const newEntry = {
  //       cost: values.cost,
  //       inStock: values.inStock,
  //       costFromVendor: values.costFromVendor,
  //       date: new Date(),
  //       generatedBy: store.Name,
  //     };

  //     if (Array.isArray(values.stockUpdateHistory)) {
  //       values.stockUpdateHistory.push(newEntry);
  //     } else {
  //       values.stockUpdateHistory = [newEntry];
  //     }
  //   }

  //   // Prepare formData
  //   for (let key in values) {
  //     if (key === "stockUpdateHistory" && Array.isArray(values[key])) {
  //       values.stockUpdateHistory.forEach((data, index) => {
  //         for (let field in data) {
  //           formData.append(`stockUpdateHistory[${index}][${field}]`, data[field]);
  //         }
  //       });
  //     } else if (typeof values[key] === "object" && values[key] !== null) {
  //       formData.append(key, JSON.stringify(values[key]));
  //     } else if (values[key] !== undefined && values[key] !== null) {
  //       formData.append(key, values[key]);
  //     }
  //   }

  //   const headers = { "Content-Type": "multipart/form-data" };

  //   setLoading(true);
  //   performRequest("PATCH", `/materialPlanning/updateHMInvetory/${id}`, formData, headers)
  //     .then((res) => {
  //       if (res.status === 200) {
  //         Toast("success", "HM Inventory updated successfully!");
  //         navigate(`/hydroponic-material-inventory`);
  //       } else {
  //         Toast("error", "Error while updating!");
  //       }
  //     })
  //     .catch((err) => {
  //       CustomErrorResponse(err);
  //     })
  //     .finally(() => setLoading(false));
  // };

  const handelSubmit = (values) => {
    // const formData = new FormData();

    // // 1️⃣ Update stockUpdateHistory if cost or inStock changed
    // if (values.cost !== data.cost || values.inStock !== data.inStock) {
    //   const newEntry = {
    //     cost: values.cost,
    //     inStock: values.inStock,
    //     costFromVendor: values.costFromVendor,
    //     date: new Date(),
    //     generatedBy: store.Name,
    //   };

    //   if (Array.isArray(values.stockUpdateHistory)) {
    //     values.stockUpdateHistory = [...values.stockUpdateHistory, newEntry];
    //   } else {
    //     values.stockUpdateHistory = [newEntry];
    //   }
    // }

    // // 1️⃣ Update item Details

    // if (values) {
    //   const newEntry = values

    //   if (Array.isArray(values.updateDetails)) {
    //     values.updateDetails = [...values.updateDetails, newEntry];
    //   } else {
    //     values.updateDetails = [newEntry];
    //   }
    // }

    // // 2️⃣ Build FormData
    // for (let key in values) {
    //   const value = values[key];

    //   if (key === "stockUpdateHistory" && Array.isArray(value)) {
    //     value.forEach((item, index) => {
    //       for (let field in item) {
    //         if (item[field] !== undefined && item[field] !== null) {
    //           formData.append(
    //             `stockUpdateHistory[${index}][${field}]`,
    //             item[field]
    //           );
    //         }
    //       }
    //     });
    //   } else if (value instanceof File || value instanceof Blob) {
    //     formData.append(key, value);
    //   } else if (typeof value === "object" && value !== null) {
    //     formData.append(key, JSON.stringify(value));
    //   } else if (value !== undefined && value !== null) {
    //     formData.append(key, value);
    //   }
    // }

    const formData = new FormData();

    // 🧠 1️⃣ Stock Update History (your existing logic)
    if (values.cost !== data.cost || values.inStock !== data.inStock) {
      const newEntry = {
        cost: values.cost,
        inStock: values.inStock,
        costFromVendor: values.costFromVendor,
        date: new Date(),
        generatedBy: store.Name,
      };

      if (Array.isArray(values.stockUpdateHistory)) {
        values.stockUpdateHistory = [...values.stockUpdateHistory, newEntry];
      } else {
        values.stockUpdateHistory = [newEntry];
      }
    }

    // 🧠 2️⃣ General Update History — capture what actually changed
    const changedFields = {};

    Object.keys(values).forEach((key) => {
      // Ignore certain non-data keys if needed
      if (
        key === "stockUpdateHistory" ||
        key === "updateDetails" ||
        key === "id" ||
        key === "createdAt" ||
        key === "updatedAt"
      ) {
        return;
      }

      const oldValue = data[key];
      const newValue = values[key];

      // Only record if changed (shallow compare)
      if (JSON.stringify(oldValue) !== JSON.stringify(newValue)) {
        changedFields[key] = { old: oldValue, new: newValue };
      }
    });

    if (Object.keys(changedFields).length > 0) {
      const updateEntry = {
        changedFields,
        updatedBy: store?.Name || "Unknown",
        updatedAt: new Date(),
      };

      if (Array.isArray(values.updateDetails)) {
        values.updateDetails = [...values.updateDetails, updateEntry];
      } else {
        values.updateDetails = [updateEntry];
      }
    }

    // 🧱 3️⃣ Build FormData for backend
    for (let key in values) {
      const value = values[key];

      if (key === "stockUpdateHistory" && Array.isArray(value)) {
        value.forEach((item, index) => {
          for (let field in item) {
            if (item[field] !== undefined && item[field] !== null) {
              formData.append(
                `stockUpdateHistory[${index}][${field}]`,
                item[field]
              );
            }
          }
        });
      } else if (key === "updateDetails" && Array.isArray(value)) {
        formData.append("updateDetails", JSON.stringify(value));
      } else if (value instanceof File || value instanceof Blob) {
        formData.append(key, value);
      } else if (typeof value === "object" && value !== null) {
        formData.append(key, JSON.stringify(value));
      } else if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    }

    // 3️⃣ API Call
    const headers = { "Content-Type": "multipart/form-data" };
    setLoading(true);

    performRequest(
      "PATCH",
      `/materialPlanning/updateHMInvetory/${id}`,
      formData,
      headers
    )
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "HM Inventory updated successfully!");
          navigate(`/hydroponic-material-inventory`);
        } else {
          Toast("error", "Error while updating!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    performRequest("GET", "/poDcPi/getAllVendorList")
      .then((res) => setVendorList(res.data))
      .catch((err) => CustomErrorResponse(err));
  }, []);
  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/materialPlanning/getHMInvetory/${id}`)
      .then((res) => {
        if (res.status === 200) {
          let data = { fabricationProcess: [], ...res.data };
          setHMInventoryInfo(data);
          setData(res.data);
        } else {
          Toast("error", "Error while getting HM inventory!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">Edit Inventory</h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <Formik
              initialValues={hmInventoryInfo}
              validationSchema={HMInventorySchema}
              onSubmit={handelSubmit}
            >
              {(props) => (
                <Form>
                  <div className="card-body">
                    <div className="mb-3 row">
                      <label className="w-25 form-label required col-3">
                        Item Name
                      </label>

                      <div className="w-100 col">
                        <CustomInput name="item" type="text" />
                        {props.touched.item && props.errors.item && (
                          <p className="text-danger">{props.errors.item}</p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Short Name
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="shortName" />
                        {props.touched.shortName && props.errors.shortName && (
                          <p className="text-danger">
                            {props.errors.shortName}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label required">HSN</label>
                      <div className="w-100 col">
                        <CustomInput name="hsn" type="text" />
                        {props.touched.hsn && props.errors.hsn && (
                          <p className="text-danger">{props.errors.hsn}</p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Measurement Unit
                      </label>
                      <div className="w-100 col">
                        <CustomSelect type="text" name="unit">
                          <option value="">Select</option>
                          <option value="nos">Nos</option>
                          <option value="kg">Kg</option>
                          <option value="grams">Grams</option>
                          <option value="ltr">Litre</option>
                          <option value="ml">ML</option>
                          <option value="packs">Packs</option>
                          <option value="pair">Pair</option>
                          <option value="sqm">SqM</option>
                          <option value="sqft">SqFt</option>
                          <option value="mtr">Meters</option>
                          {/* <option value="pcs">Pices</option> */}
                        </CustomSelect>

                        {props.touched.unit && props.errors.unit && (
                          <p className="text-danger">{props.errors.unit}</p>
                        )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Product Unit
                      </label>
                      <div className="w-100 col">
                        <CustomSelect type="text" name="proUnit">
                          <option value="">Select</option>
                          <option value="nos">Nos</option>
                          <option value="kg">Kg</option>
                          <option value="grams">Grams</option>
                          <option value="ltr">Litter</option>
                          <option value="ml">ML</option>
                          <option value="packs">Packs</option>
                          <option value="pair">Pair</option>
                          <option value="sqm">SqM</option>
                          <option value="sqft">SqFt</option>
                          <option value="mtr">Meters</option>
                          {/* <option value="pcs">Pices</option> */}
                        </CustomSelect>

                        {props.touched.proUnit && props.errors.proUnit && (
                          <p className="text-danger">{props.errors.proUnit}</p>
                        )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="col-3 form-label required text-capitalize ">
                        {`Cost Per ${props.values.proUnit || "Unit"}`}
                      </label>
                      <div className="col">
                        <CustomInput
                          name="cost"
                          type="text"
                          className="form-control"
                        />
                        {props.touched.cost && props.errors.cost && (
                          <p className="text-danger">{props.errors.cost}</p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="col-3 form-label">Weight</label>
                      <div className="col">
                        <div className="input-group">
                          <CustomInput
                            name="weight"
                            type="text"
                            step="0.01"
                            className="form-control"
                            placeholder="Enter weight"
                          />
                          {props.touched.weight && props.errors.weight && (
                            <p className="text-danger">{props.errors.weight}</p>
                          )}

                          <CustomSelect type="text" name="weight_unit">
                            <option value="">Select</option>
                            <option value="kg">kg</option>
                            <option value="g">g</option>
                            <option value="oz">oz</option>
                            <option value="lb">lb</option>
                            <option value="nos">Nos</option>
                            <option value="kg">Kg</option>
                            <option value="grams">Grams</option>
                            <option value="ltr">Litter</option>
                            <option value="ml">ML</option>
                            <option value="packs">Packs</option>
                            <option value="pair">Pair</option>
                            <option value="sqm">SqM</option>
                            <option value="sqft">SqFt</option>
                            <option value="mtr">Meters</option>
                          </CustomSelect>
                          {props.touched.weight_unit &&
                            props.errors.weight_unit && (
                              <p className="text-danger">
                                {props.errors.weight_unit}
                              </p>
                            )}
                        </div>
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 col-form-label col-3">
                        Technical Specification
                      </label>
                      <div className="w-100 col">
                        <textarea
                          name="productSpecification"
                          className="form-control"
                          placeholder="Enter technical specification"
                          rows={3}
                          value={props.values.productSpecification} // bind value
                          onChange={props.handleChange} // update Formik state
                          onBlur={props.handleBlur} // mark as touched for validation
                        />

                        {props.touched.productSpecification &&
                          props.errors.productSpecification && (
                            <p className="text-danger mt-1">
                              {props.errors.productSpecification}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Brand Name
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="brandName" />
                        {props.touched.brandName && props.errors.brandName && (
                          <p className="text-danger">
                            {props.errors.brandName}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Size
                      </label>
                      <div className="w-100 col">
                        <CustomSelect type="text" name="size">
                          <option value="">Select</option>
                          <option value="Small">200g - 1kg (Small)</option>
                          <option value="Medium">1kg - 10kg (Medium)</option>
                          <option value="Large">10kg - 20kg (Large)</option>
                          <option value="Extra Large">
                            20kg - 50kg (Extra Large)
                          </option>
                          <option value="Double Extra Large">
                            50kg - 100kg (Double Extra Large)
                          </option>
                          <option value="Other">Other</option>
                        </CustomSelect>

                        {props.touched.size && props.errors.size && (
                          <p className="text-danger">{props.errors.size}</p>
                        )}
                      </div>
                    </div>
                 
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Usage Type
                      </label>
                      <div className="w-100 col d-flex flex-wrap">
                        {hydroponicOptions.map((type) => {
                          const isChecked =
                            props.values.hydroponicTypeNew.includes(type.value);
                          return (
                            <div className="form-check me-3" key={type.value}>
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id={type.value}
                                name="hydroponicTypeNew"
                                checked={isChecked}
                                onChange={(e) => {
                                  const selected = [
                                    ...props.values.hydroponicTypeNew,
                                  ];
                                  const specs = [
                                    ...props.values.specificationsNew,
                                  ];

                                  if (e.target.checked) {
                                    selected.push(type.value);
                                    specs.push({
                                      type: type.value,
                                      specification: "",
                                    });
                                  } else {
                                    const index = selected.indexOf(type.value);
                                    if (index > -1) selected.splice(index, 1);
                                    const specIndex = specs.findIndex(
                                      (item) => item.type === type.value
                                    );
                                    if (specIndex > -1)
                                      specs.splice(specIndex, 1);
                                  }

                                  props.setFieldValue(
                                    "hydroponicTypeNew",
                                    selected
                                  );
                                  props.setFieldValue(
                                    "specificationsNew",
                                    specs
                                  );
                                }}
                                onBlur={props.handleBlur}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={type.value}
                              >
                                {type.label}
                              </label>
                            </div>
                          );
                        })}

                        {props.touched.hydroponicTypeNew &&
                          props.errors.hydroponicTypeNew && (
                            <p className="text-danger w-100">
                              {props.errors.hydroponicTypeNew}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      {props.values.specificationsNew &&
                      props.values.specificationsNew.length > 0
                        ? props.values.specificationsNew.map((item, index) => (
                            <React.Fragment key={item.type}>
                              <label className="col-3 form-label text-capitalize">
                                {`${props.values.item} Description in ${
                                  item.type.charAt(0).toUpperCase() +
                                  item.type.slice(1)
                                } `}
                              </label>
                              <div className="col-9 mb-3">
                                <textarea
                                  type="text"
                                  className="form-control"
                                  value={item.specification}
                                  onChange={(e) => {
                                    const updated = [
                                      ...props.values.specificationsNew,
                                    ];
                                    updated[index].specification =
                                      e.target.value;
                                    props.setFieldValue(
                                      "specificationsNew",
                                      updated
                                    );
                                  }}
                                />
                              </div>
                            </React.Fragment>
                          ))
                        : ""}
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Material Type
                      </label>
                      <div className="w-100 col">
                        <select
                          className="form-select"
                          name="materialType"
                          value={props.values.materialType || ""}
                          onChange={props.handleChange}
                          onBlur={props.handleBlur}
                        >
                          <option value="">Select Material Type</option>
                          {materialTypeOptions.map((type) => (
                            <option key={type.value} value={type.value}>
                              {type.label}
                            </option>
                          ))}
                        </select>

                        {props.touched.materialType &&
                          props.errors.materialType && (
                            <p className="text-danger">
                              {props.errors.materialType}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">In stock</label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="inStock" />
                        {props.touched.inStock && props.errors.inStock && (
                          <p className="text-danger">{props.errors.inStock}</p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Cost from vendor
                      </label>
                      <div className="w-100 col">
                        <CustomSelect type="text" name="costFromVendor">
                          <option value="">Select</option>
                          {vendorList?.map((item) => {
                            return (
                              <option key={item.id} value={item.businessName}>
                                {item.businessName}
                              </option>
                            );
                          })}
                        </CustomSelect>
                        {props.touched.costFromVendor &&
                          props.errors.costFromVendor && (
                            <p className="text-danger">
                              {props.errors.costFromVendor}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Image</label>
                      <div className="w-100 col">
                        <CustomInput
                          type="file"
                          name="image"
                          onChange={(e) =>
                            props.setFieldValue("image", e.target.files[0])
                          }
                        />
                        {props.touched.image && props.errors.image && (
                          <p className="text-danger">{props.errors.image}</p>
                        )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 ">
                        Threshold limit
                      </label>

                      <div className="w-100 col">
                        <CustomInput type="text" name="thresholdLimit" />

                        {props.touched.thresholdLimit &&
                          props.errors.thresholdLimit && (
                            <p className="text-danger">
                              {props.errors.thresholdLimit}
                            </p>
                          )}
                      </div>
                    </div>
                
                    <div className="mb-3 row mt-3">
                      <label className="w-25 form-label col-3 required">
                        Location
                      </label>
                      <div className="w-100 col d-flex flex-wrap">
                        {locationOptions.map((type) => {
                          const isChecked = props?.values?.location
                            ? props?.values?.location === type?.value
                            : type?.value === "decWarehouse"; // default if empty

                          return (
                            <div className="form-check me-3" key={type?.value}>
                              <input
                                type="radio"
                                className="form-check-input"
                                id={type.value}
                                name="location"
                                value={type.value}
                                checked={isChecked}
                                onChange={() => {
                                  props.setFieldValue("location", type.value);
                                }}
                                onBlur={props.handleBlur}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={type?.value}
                              >
                                {type?.label}
                              </label>
                            </div>
                          );
                        })}

                        {props.touched.location && props.errors.location && (
                          <p className="text-danger w-100">
                            {props.errors.location}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 ">Rack Id</label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="rackId" />

                        {props.touched.rackId && props.errors.rackId && (
                          <p className="text-danger">{props.errors.rackId}</p>
                        )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                      Si Kit / Planter / Dutchbucket Count
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="count" />
                        {props.touched.count && props.errors.count && (
                          <p className="text-danger">{props.errors.count}</p>
                        )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Is Item in List
                      </label>
                      <div className="w-100 col">
                        <CustomCheckbox
                          name="iteminList"
                          type="checkbox"
                          height={"20px"}
                          width={"20px"}
                        ></CustomCheckbox>
                        {props.touched.iteminList &&
                          props.errors.iteminList && (
                            <p className="text-danger">
                              {props.errors.iteminList}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row ">
                      <label className="w-25 form-label col-3  ">
                        Need transportation
                      </label>
                      <div className="w-100 col ">
                        <CustomCheckbox
                          width={"20px"}
                          height={"20px"}
                          type="checkbox"
                          name="needTransportation"
                        />
                        {props.touched.needTransportation &&
                          props.errors.needTransportation && (
                            <p className="text-danger">
                              {props.errors.needTransportation}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Need packaging
                      </label>
                      <div className="w-100 col">
                        <CustomCheckbox
                          width={"20px"}
                          height={"20px"}
                          type="checkbox"
                          name="needPackaging"
                        />

                        {props.touched.needPackaging &&
                          props.errors.needPackaging && (
                            <p className="text-danger">
                              {props.errors.needPackaging}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Is fragile
                      </label>

                      <div className="w-100 col">
                        <CustomCheckbox
                          width={"20px"}
                          height={"20px"}
                          type="checkbox"
                          name="isFragile"
                        />
                        {props.touched.isFragile && props.errors.isFragile && (
                          <p className="text-danger">
                            {props.errors.isFragile}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Fabrication Charges Markup Percentage
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          name="fabricationChargesMarkup"
                        />
                        {props.touched.fabricationChargesMarkup &&
                          props.errors.fabricationChargesMarkup && (
                            <p className="text-danger">
                              {props.errors.fabricationChargesMarkup}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Handling Charges Percentage
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="handlingCharges" />
                        {props.touched.handlingCharges &&
                          props.errors.handlingCharges && (
                            <p className="text-danger">
                              {props.errors.handlingCharges}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Optional Warranty Coverge Per Unit
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          name="optionalWarrantyCovergePerUnit"
                        />
                        {props.touched.optionalWarrantyCovergePerUnit &&
                          props.errors.optionalWarrantyCovergePerUnit && (
                            <p className="text-danger">
                              {props.errors.optionalWarrantyCovergePerUnit}
                            </p>
                          )}
                      </div>

                      <div className="mb-3 row mt-3">
                        <label className="w-25 form-label col-3 required">
                          GST Percentage
                        </label>
                        <div className="w-100 col d-flex flex-wrap">
                          {gstOptions.map((type) => {
                            const isChecked =
                              props?.values?.gst === type?.value;
                            return (
                              <div
                                className="form-check me-3"
                                key={type?.value}
                              >
                                <input
                                  type="radio"
                                  className="form-check-input"
                                  id={type.value}
                                  name="gst"
                                  value={type.value}
                                  checked={isChecked}
                                  onChange={() => {
                                    props.setFieldValue("gst", type.value);
                                  }}
                                  onBlur={props.handleBlur}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={type?.value}
                                >
                                  {type?.label}
                                </label>
                              </div>
                            );
                          })}

                          {props.touched.gst && props.errors.gst && (
                            <p className="text-danger w-100">
                              {props.errors.gst}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Fabrication Process
                      </label>
                      <div className="w-100 col d-flex flex-wrap">
                        {fabricationProcessOptions.map((type) => {
                          const isChecked =
                            props?.values?.fabricationProcess?.includes(
                              type?.value
                            );
                          return (
                            <div className="form-check me-3" key={type?.value}>
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id={type?.value}
                                name="fabricationProcess"
                                checked={isChecked}
                                onChange={(e) => {
                                  const selected = [
                                    ...props?.values?.fabricationProcess,
                                  ];

                                  if (e.target.checked) {
                                    selected?.push(type?.value);
                                  } else {
                                    const index = selected.indexOf(type.value);
                                    if (index > -1) selected.splice(index, 1);
                                    // const specIndex = specs.findIndex(
                                    //   (item) => item.type === type.value
                                    // );
                                    // if (specIndex > -1)
                                    //   specs.splice(specIndex, 1);
                                  }

                                  props.setFieldValue(
                                    "fabricationProcess",
                                    selected
                                  );
                                  // props.setFieldValue(
                                  //   "specificationsNew",
                                  //   specs
                                  // );
                                }}
                                onBlur={props.handleBlur}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={type?.value}
                              >
                                {type?.label}
                              </label>
                            </div>
                          );
                        })}

                        {props.touched.fabricationProcess &&
                          props.errors.fabricationProcess && (
                            <p className="text-danger w-100">
                              {props.errors.fabricationProcess}
                            </p>
                          )}
                      </div>
                    </div>
                  </div>
                  <div className="card-footer">
                    <div className="btn-list justify-content-end">
                      <FormSubmitButton buttonText="update Inventory" />

                      <SimpleButton buttonText="Cancel" type="secondary" />
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h3>Stock Update History</h3>
            </div>
            <div className="card-body">
              {!data?.stockUpdateHistory ||
              data?.stockUpdateHistory?.length < 1 ? (
                <h3>No history available</h3>
              ) : (
                <div className="table-responsive">
                  {data && (
                    <table className="table table-vcenter">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>cost</th>
                          <th>in stock</th>
                          <th>cost From Vendor</th>
                          <th>invoice / pi Num</th>
                          <th>updated by</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.stockUpdateHistory?.map((lineItem, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                {lineItem?.date
                                  ? extractDate(lineItem.date)
                                  : "N/A"}
                              </td>
                              <td>{lineItem?.cost || "N/A"}</td>
                              <td>{lineItem?.inStock || "N/A"}</td>
                              <td>
                                {(
                                  lineItem?.costFromVendor || "N/A"
                                ).toUpperCase()}
                              </td>
                              <td>{lineItem?.invoiceNumber || "N/A"}</td>
                              <td>
                                {(lineItem?.generatedBy || "N/A").toUpperCase()}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  )}
                </div>
              )}
            </div>
          </div>
          {data?.stockReducedHistory?.length < 1 && (
            <div className="card my-4">
              <div className="card-header">
                <h3>SI Kit Reduced Stock History</h3>
              </div>
              <div className="card-body">
                {!data?.stockReducedHistory ||
                data?.stockReducedHistory?.length < 1 ? (
                  <h3>No history available</h3>
                ) : (
                  <div className="table-responsive">
                    {data && (
                      <table className="table table-vcenter">
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Old Stock</th>
                            <th>Reduced Qty</th>
                            <th>New Stock</th>
                            <th>Generated By</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data?.stockReducedHistory?.map((lineItem, index) => {
                            return (
                              <tr key={index}>
                                <td>
                                  {lineItem?.date
                                    ? extractDate(lineItem.date)
                                    : "N/A"}
                                </td>
                                <td>{lineItem?.oldStock || "N/A"}</td>
                                <td>{lineItem?.reducedQty || "N/A"}</td>
                                <td>{lineItem?.newStock || "N/A"}</td>
                                <td>
                                  {(
                                    lineItem?.generatedBy || "N/A"
                                  ).toUpperCase()}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}
          <div className="card my-4">
            <div className="card-header">
              <h3>Update History</h3>
            </div>
            <div className="card-body">
              {!data?.updateDetails || data?.updateDetails?.length < 1 ? (
                <h3>No update history available</h3>
              ) : (
                <div className="table-responsive">
                  {data && (
                    <table className="table table-vcenter">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Old Item Name</th>
                          <th>New Item Name</th>
                          <th>Old Specification</th>
                          <th>New Specification</th>
                          <th>Old Cost</th>
                          <th>New Cost</th>
                          <th>Old Unit</th>
                          <th>New Unit</th>
                          <th>updated by</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.updateDetails?.map((lineItem, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                {lineItem?.updatedAt
                                  ? extractDate(lineItem.updatedAt)
                                  : "N/A"}
                              </td>
                              <td>
                                {lineItem?.changedFields?.item?.old || "-"}
                              </td>
                              <td>
                                {lineItem?.changedFields?.item?.new || "-"}
                              </td>
                              <td>
                                {lineItem?.changedFields?.specificationsNew
                                  ?.old ? (
                                  <div>
                                    {lineItem?.changedFields?.specificationsNew?.old?.map(
                                      (spe, index) => (
                                        <>
                                          <p className="p-0 m-0">
                                            Type: {spe?.type || "-"}
                                          </p>
                                          <span>
                                            Specification:
                                            {spe?.specification || "-"}
                                          </span>
                                        </>
                                      )
                                    )}
                                  </div>
                                ) : (
                                  "-"
                                )}
                              </td>
                              <td>
                                {lineItem?.changedFields?.specificationsNew
                                  ?.new ? (
                                  <div>
                                    {lineItem?.changedFields?.specificationsNew?.new?.map(
                                      (spe, index) => (
                                        <>
                                          <p className="p-0 m-0">
                                            Type: {spe?.type || "-"}
                                          </p>
                                          <span>
                                            Specification:
                                            {spe?.specification || "-"}
                                          </span>
                                        </>
                                      )
                                    )}
                                  </div>
                                ) : (
                                  "-"
                                )}
                              </td>
                              <td>
                                {lineItem?.changedFields?.cost?.old || "-"}
                              </td>
                              <td>
                                {lineItem?.changedFields?.cost?.new || "-"}
                              </td>
                              <td>
                                {lineItem?.changedFields?.unit?.old || "-"}
                              </td>
                              <td>
                                {lineItem?.changedFields?.unit?.new || "-"}
                              </td>
                              <td>
                                {(lineItem?.updatedBy || "N/A").toUpperCase()}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default EditHMInentory;
